<template lang="pug">
  v-container(fluid)
    h2.text-center {{translations.title}}

    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}")
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items", :key="'item'+ind")
                td
                  span.fantasy__block-width--8 {{ item.name }}
                td
                  CategoryInfoDialog(:data="item")
                td(v-if="hasPermission('views.categories.editCategory')")
                  BaseDialog(type="edit", :title="translationsForm.title.edit + item.name" v-slot="{close, opened}")
                    CategoryEdit(@successEdit="updateCategories(opened,close)", :clearForm="opened", :translations="translationsForm", :category="item")
      BaseDialog(v-if="hasPermission('views.categories.createCategory')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
        CategoryCreate(@successCreate="updateCategories(opened,close)", :clearForm="opened", :translations="translationsForm")

</template>

<script>

  import CategoryInfoDialog from "@/components/dialogs/info/CategoryInfoDialog";
  import CategoryCreate from '@/components/forms/CategoryCreate';
  import CategoryEdit from '@/components/forms/CategoryEdit';

  export default {
    name: "CategoriesIndex",
    components: {
      CategoryInfoDialog,
      CategoryCreate,
      CategoryEdit,
    },
    data: () => ({
      namefilter: '',
    }),
    computed:{
      translations() {
        return this.$t("views.categoriesIndex");
      },
      translationsForm() {
        return this.$t("forms.category");
      },
      headers() {
        let headers = [
          {
            text: this.translations.tableHead.name,
            value: 'name'
          },
          {
            text: '',
            value: 'info',
            sortable: false
          },
        ];
        if(this.hasPermission('views.categories.editCategory')){
          headers.push(
            {
              text: '',
              value: 'edit',
              sortable: false
            });
        }
        return headers;
      },
      datos(){
        if(this.categoriesListAll.length){
          return this.categoriesListAll.map(category =>{
            return {
              _id: category._id,
              name: category.n,
              items: category.ct != undefined && category.ct.length ? category.ct : [],
            }
          });
        } else {
          return [];
        }
      },
      categoriesListAll() {
        return this.$store.state.fantasy.categories;
      },
    },
    created() {
      this.$store.dispatch('getCategories');
    },
    methods:{
      updateCategories(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.getOperators();
        }
      },
    }
  }
</script>

<style lang="sass">
</style>